<template>
  <div class="page-wrapper">
    <article id="post-1905" class="full post-1905 page type-page status-publish hentry">
      <div class="page-content clearfix the-content-parent">
        <div data-elementor-type="wp-page" data-elementor-id="1905" class="elementor elementor-1905" data-elementor-post-type="page">
          
          <BannerSection /> 
          <SloganSection />
          <AboutUsSection />
          <ProjectSection />
          <!-- <CategorySection /> -->
          <ServicesSection />
          <FactsSection />
          <SafetySection />
          <ThinkerSection />
          <LeadershipSection />
          <NewsSection />
          <OurClientSection />
        </div>
      </div>
    </article>
  </div>
</template>
<script>
  import "@/assets/css/home.css";
  import { onMounted } from "vue";
  import BannerSection from './Home/BannerSectionComponent.vue';
  import SloganSection from './Home/SloganSectionComponent.vue';
  import AboutUsSection from './Home/AboutUsSectionComponent.vue';
  import ProjectSection from './Home/ProjectSectionComponent.vue';
  import ServicesSection from './Home/ServicesSectionComponent.vue';
  import FactsSection from './Home/FactsSectionComponent.vue';
  import ThinkerSection from './Home/ThinkerSectionComponent.vue';
  import LeadershipSection from './Home/LeadershipSectionComponent.vue';
  import NewsSection from './Home/NewsSectionComponent.vue';
  import OurClientSection from './Home/OurClientsSectionComponent.vue';
  import SafetySection from "./Home/SafetySectionComponent.vue";

  export default {
    name: 'HomeView',
    setup() {

      onMounted(async() => {
      });

      return {
        modules: [],
      };
    },
    components: {
      BannerSection,
      AboutUsSection,
      SloganSection,
      ProjectSection,
      ServicesSection,
      FactsSection,
      SafetySection,
      ThinkerSection,
      LeadershipSection,
      NewsSection,
      OurClientSection,
    },
  }
</script>